import './AboutUs.css';
import Navigation from './Navigation';
import Footer from './Footer';
import rowingBoat from '../assets/rowing-boat.jpg';
import storyImage from '../assets/BLUE STAR ROWING WEEKEND 1 -101.jpg';

const AboutUs = () => {
  const starLogo = 'https://assets.bluestar-rowing.com/assets/logos/RGB_Blue_Star_Rowing_Logo_Rose_Colour.png';

  return (
    <>
      <Navigation />
      <section className="section-seamless about-section">
        <div className="about-hero">
          <div
            className="about-hero-background"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.55), rgba(0,0,0,0.9)), url(${rowingBoat})`
            }}
          />
          <div className="about-hero-content">
            <p className="about-hero-kicker">WHO ARE</p>
            <h1 className="about-hero-title">
              BLUE STAR <span>ROWING</span>
            </h1>
            <p className="about-hero-text">
              As a team of three we are rowing 3,000 miles unsupported across the Atlantic Ocean.
              Partnering with Gym Possible to raise funds to create a state-of-the-art accessible 
              gym combining physiotherapy, counselling services, and a welcoming café, enabling disabled athletes t
              o train for greater independence, fostering social connection and mental wellbeing.
            </p>
          </div>
        </div>

        <div className="about-main">
          <div className="about-highlight">
            <div className="about-highlight-left">
              <img
                src={starLogo}
                alt="Blue Star Rowing star logo"
                className="about-highlight-logo"
              />
              <div className="about-highlight-copy">
                <h2 className="about-highlight-title">
                  We&apos;re not elite athletes or pro adventurers
                </h2>
                <p className="about-highlight-text">
                  We&apos;re three mates who backed ourselves to take on something way bigger than us,
                  and we&apos;re figuring it out as we go.
                </p>
              </div>
            </div>
            <div
              className="about-highlight-image"
              aria-hidden="true"
            />
          </div>

          <div className="about-profile-band">

            <div className="about-profile-inner">
            <div className="about-profile-content">
                <p className="about-profile-kicker">I&apos;M OLI,</p>
                <h2 className="about-profile-title">
                  the one trying to look like I know what I&apos;m doing while keeping this boat pointing
                  vaguely in the right direction.
                </h2>
                <div className="about-profile-divider" aria-hidden="true" />
                <p className="about-profile-text">
                  When I&apos;m not busy pretending to be sensible, I&apos;m usually found sleeping in a bivvy bag halfway up a hill,
                   skiiing down somthing I probably shouldn&apos;t, or saying "yes" to adventures that most people would politely decline. 
                   Rowing the Atlantic is easily my most ridiculous idea yet, and I can&apos;t wait to see what the ocean has to say
                  about it.
                </p>
              </div>
              <div className="about-profile-image" aria-hidden="true" />
            </div>

            <div className="about-profile-inner">
              <div className="about-profile-image" aria-hidden="true" />
              <div className="about-profile-content">
              <p className="about-profile-kicker">I’M MARK,</p>
                <h2 className="about-profile-title">
                  the clumsy one on the boat. The guy
                  who’s out of sync with the oars, spilling
                  the coffee, or tripping over the kit bag.
                </h2>
                <div className="about-profile-divider" aria-hidden="true" />
                <p className="about-profile-text">
                  I’ve always thrown myself into endurance challenges –
                  marathons, triathlons, anything that pushes me to my edge.
                  But this is something else entirely. It’s equal parts terrifying
                  and exciting, and I honestly can’t wait to get stuck in.
                </p>
              </div>
            </div>

            <div className="about-profile-inner">
              <div className="about-profile-content">
                <p className="about-profile-kicker">I’M ARCHIE,</p>
                <h2 className="about-profile-title">
                  the one with questionable playlist choices,
                  and a habit of saying “I’m sure that’ll fix
                  itself” when it probably won’t.
                </h2>
                <div className="about-profile-divider" aria-hidden="true" />
                <p className="about-profile-text">
                  Marathons have given me a taste of endurance—but this is a
                  whole new level. It’s Type 2 fun at its finest: the kind that hurts
                  at the time but gives you stories for years. I’m here for the
                  madness, the memories, and the moments that’ll make us
                  crease with laughter at 3am in the middle of the Atlantic.
                </p>
              </div>
              <div className="about-profile-image" aria-hidden="true" />
            </div>

            <div className="about-story-inline">
              <div className="about-story-image">
                <img
                  src={storyImage}
                  alt="Blue Star Rowing crew training on the water"
                />
              </div>
              <div className="about-story-text">
                <p className="about-story-kicker">JOIN THE EFFORT</p>
                <h2 className="about-story-heading">
                  TOGETHER
                </h2>
                <p className="about-story-subtitle">
                  Follow our training
                </p>
                <p className="about-story-subtext">
                  And show us your effort at home.
                </p>
                <div className="about-story-divider" aria-hidden="true" />
                <p className="about-story-body">
                  Tag us on social media and help share the word with your own training sessions keeping
                  up with us online. We will post weekly updates and splits as well as sessions with the
                  fantastic folks at Gym Possible. Follow along with us and push yourself to the limit by
                  sharing your journey and helping raise awareness of Blue Star Rowing and Gym Possible.
                </p>
              </div>
              

            </div>

            <p className="about-story-footer">
              Use hashtags <strong>#TheEffortItTakes</strong> and <strong>#BlueStarRowing</strong> to join
              our growing community helping share the message and goal behind our mission. Show us what
              you are made of and the effort it takes for a page shoutout and community competitions.
            </p>

          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutUs;

